<template>
  <div class="app-container">
    <div class="mb-10">
      <el-button type="text" icon="el-icon-circle-plus-outline" @click="appendNode">{{ $t("publics.add") }}</el-button>
    </div>
    <el-tree v-loading="treeLoading" class="my-tree" :data="treeData" node-key="id" default-expand-all :expand-on-click-node="true">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-button v-if="node.level < 3" class="tree-btn" type="text" icon="el-icon-circle-plus-outline" @click="() => append(data)"> </el-button>
          <el-button class="tree-btn" type="text" icon="el-icon-edit" @click="() => editor(node, data)"> </el-button>
          <el-button class="tree-btn" type="text" icon="el-icon-delete" @click="() => remove(node, data)"> </el-button>
        </span>
      </span>
    </el-tree>

    <el-dialog :visible.sync="visible.editRoute" width="600px" :title="isUpdate ? $t('publics.edit') : $t('publics.add')">
      <el-form label-width="160px" :model="form" :rules="formRules" ref="form" v-loading="formLoading">
        <el-form-item :label="$t('menusmanage.name')" prop="name">
          <el-input class="input-medium" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menusmanage.parentName')" prop="parentName">
          <el-input class="input-medium" v-model="form.parentName" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('menusmanage.icon')" prop="icon">
          <div class="flex flex-a-c">
            <template v-if="form.icon">
              <div class="icon-box" v-if="form.icon.includes('el-icon')">
                <i :class="form.icon"></i>
              </div>
              <div class="icon-box" v-else>
                <svg-icon :icon-class="form.icon"></svg-icon>
              </div>
            </template>
            <el-popover placement="right" width="330" trigger="click">
              <div class="flex flex-wrap">
                <div v-for="(item, index) in icons" :key="index">
                  <div class="icon-box" v-if="item.includes('el-icon')" @click="form.icon = item">
                    <i :class="item"></i>
                  </div>
                  <div class="icon-box" v-else @click="form.icon = item">
                    <svg-icon :icon-class="item"></svg-icon>
                  </div>
                </div>
                <div class="icon-box" @click="form.icon = ''">{{ $t("menusmanage.not") }}</div>
              </div>
              <el-button slot="reference" class="ml-10" type="primary" plain>{{ $t("menusmanage.sel") }}</el-button>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item :label="$t('menusmanage.url')" prop="url">
          <el-input class="input-medium" v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menusmanage.sort')" prop="sort">
          <el-input class="input-medium" v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menusmanage.isShow')" prop="isShow">
          <el-switch v-model="form.isShow"></el-switch>
        </el-form-item>
        <el-form-item label="按钮">
          <table>
            <thead>
              <tr>
                <th>按钮名称</th>
                <th>按钮权限值</th>
                <th><el-button size="mini" @click="onPermisAdd">+</el-button></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in btns" :key="index">
                <td style="width: 100px"><el-input size="mini" v-model="item.name"></el-input></td>
                <td style="width: 130px"><el-input size="mini" v-model="item.permission"></el-input></td>
                <td><el-button size="mini" @click="onPermisMinus(index)">-</el-button></td>
              </tr>
            </tbody>
          </table>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible.editRoute = false">{{ $t("menusmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmitForm">{{ $t("menusmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { icons } from "@/utils/objects.js"
import { getMenusTree, addMenu, getMenuDetail, updateMenu, deleteMenu } from "@/api/user"
export default {
  name: "MenusManager",
  data() {
    return {
      icons,
      treeLoading: false,
      formLoading: false,
      visible: {
        editRoute: false
      },
      btns: [
        {
          name: "",
          permission: ""
        }
      ],
      form: {
        id: "",
        name: "",
        parentName: "",
        parentId: "",
        icon: "dot",
        url: "",
        sort: "",
        isShow: true,
        EnglishName: ""
      },
      formRules: {},
      treeData: [
        {
          label: "",
          children: [
            {
              label: ""
            }
          ]
        },
        {
          label: "",
          children: [
            {
              label: ""
            },
            {
              label: ""
            }
          ]
        }
      ],
      isUpdate: false
    }
  },
  created() {
    this.formRules = {
      name: [{ required: true, message: this.$t("menusmanage.placeholder"), trigger: "blur" }],
      url: [{ required: true, message: this.$t("menusmanage.placeholder1"), trigger: "blur" }],
      sort: [{ required: true, message: this.$t("menusmanage.placeholder2"), trigger: "blur" }]
    }
    this.loadMenusTree()
  },
  methods: {
    onPermisAdd() {
      if (!this.checkPermis()) {
        return
      }
      this.btns.push({
        name: "",
        is_sel: false,
        permission: ""
      })
    },
    checkPermis() {
      for (let i = 0; i < this.btns.length; i++) {
        if (this.btns[i].name == "" || this.btns[i].permission == "") {
          this.$message.info("权限名称或权限值不能为空")
          return false
        }
      }
      return true
    },
    onPermisMinus(index) {
      this.btns.splice(index, 1)
    },
    loadMenusTree() {
      this.treeLoading = true
      getMenusTree()
        .then((res) => {
          this.treeData = res.dt
        })
        .finally(() => {
          this.treeLoading = false
        })
    },
    onSubmitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          let reqData = {
            Id: this.form.id,
            Name: this.form.name,
            ParentName: this.form.parentName,
            ParentId: this.form.parentId,
            IconName: this.form.icon,
            Url: this.form.url,
            SortNo: this.form.sort,
            Status: this.form.isShow ? 0 : -1,
            EnglishName: this.form.EnglishName,
            btnPermissions: JSON.stringify(this.btns)
          }
          if (this.isUpdate) {
            updateMenu(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editRoute = false
                this.loadMenusTree()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addMenu(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editRoute = false
                this.loadMenusTree()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },
    remove(node, data) {
      this.$confirm(`${this.$t("menusmanage.removetitle")}`, `${this.$t("menusmanage.tic")}`, {
        type: "warning"
      })
        .then((res) => {
          const loading = this.$loading()
          deleteMenu({
            Id: data.id
          })
            .then((res) => {
              this.$message.success(`${this.$t("publics.deletesuccessful")}`)
              this.loadMenusTree()
            })
            .finally(() => {
              loading.close()
            })
        })
        .catch(() => {})
    },
    editor(node, data) {
      this.isUpdate = true
      this.visible.editRoute = true
      this.form.id = data.id
      this.formLoading = true
      getMenuDetail({
        pid: data.id
      })
        .then((res) => {
          let data = res.dt[0]
          this.form.name = data.Name
          this.form.parentName = data.ParentName
          this.form.parentId = data.ParentId
          this.form.icon = data.IconName
          this.form.url = data.Url
          this.form.sort = data.SortNo
          this.form.isShow = data.Status == 0
          this.form.EnglishName = data.EnglishName
          this.btns = []
          if (data.btnPermissions && data.btnPermissions.length > 0) this.btns = JSON.parse(data.btnPermissions)
        })
        .finally(() => {
          this.formLoading = false
        })
    },
    append(data) {
      this.isUpdate = false
      this.form = this.$options.data().form
      this.form.parentName = data.label
      this.form.parentId = data.id
      this.visible.editRoute = true
    },
    appendNode() {
      this.isUpdate = false
      this.form = this.$options.data().form
      this.form.parentName = this.$t("menusmanage.parentNamedata")
      this.visible.editRoute = true
    }
  }
}
</script>

<style scoped lang="scss">
.my-tree {
  width: 355px;
  height: 100%;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.tree-btn {
  padding: 9px 5px;
}

.icon-box {
  width: 50px;
  height: 50px;
  border: 1px solid #ebeef5;
  font-size: 24px;
  line-height: 50px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
